/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

/* ;( function( $, window, undefined ) {

  'use strict';

  // global
  var Modernizr = window.Modernizr;

  $.CBPQTRotator = function( options, element ) {
    this.$el = $( element );
    this._init( options );
  };

  // the options
  $.CBPQTRotator.defaults = {
    // default transition speed (ms)
    speed : 700,
    // default transition easing
    easing : 'ease',
    // rotator interval (ms)
    interval : 8000
  };

  $.CBPQTRotator.prototype = {
    _init : function( options ) {

      // options
      this.options = $.extend( true, {}, $.CBPQTRotator.defaults, options );
      // cache some elements and initialize some variables
      this._config();
      // show current item
      this.$items.eq( this.current ).addClass( 'qtcurrent' );
      // set the transition to the items
      if( this.support ) {
        this._setTransition();
      }
      // start rotating the items
      this._startRotator();

    },
    _config : function() {

      // the content items
      this.$items = this.$el.children( 'div.qtcontent' );
      // total items
      this.itemsCount = this.$items.length;
      // current item´s index
      this.current = 0;
      // support for CSS Transitions
      this.support = Modernizr.csstransitions;
      // add the progress bar
      if( this.support ) {
        this.$progress = $( '<span class="qtprogress"></span>' ).appendTo( this.$el.closest('.qt-container') );
      }

    },
    _setTransition : function() {
      setTimeout( $.proxy( function() {
        this.$items.css( 'transition', 'opacity ' + this.options.speed + 'ms ' + this.options.easing );
      }, this ), 25 );
    },
    _startRotator: function() {

      if( this.support ) {
        this._startProgress();
      }

      setTimeout( $.proxy( function() {
        if( this.support ) {
          this._resetProgress();
        }
        this._next();
        this._startRotator();
      }, this ), this.options.interval );

    },
    _next : function() {

      // hide previous item
      this.$items.eq( this.current ).removeClass( 'qtcurrent' );
      // update current value
      this.current = this.current < this.itemsCount - 1 ? this.current + 1 : 0;
      // show next item
      this.$items.eq( this.current ).addClass('qtcurrent');

    },
    _startProgress : function() {

      setTimeout( $.proxy( function() {
        this.$progress.css( { transition : 'width ' + this.options.interval + 'ms linear', width : '100%' } );
      }, this ), 25 );

    },
    _resetProgress : function() {
      this.$progress.css( { transition : 'none', width : '0%' } );
    },
    destroy : function() {
      if( this.support ) {
        this.$items.css( 'transition', 'none' );
        this.$progress.remove();
      }
      this.$items.removeClass( 'qtcurrent' ).css( {
        'position' : 'relative',
        'z-index' : 100,
        'pointer-events' : 'auto',
        'opacity' : 1
      } );
    }
  };

  var logError = function( message ) {
    if ( window.console ) {
      window.console.error( message );
    }
  };

  $.fn.cbpQTRotator = function( options ) {
    if ( typeof options === 'string' ) {
      var args = Array.prototype.slice.call( arguments, 1 );
      this.each(function() {
        var instance = $.data( this, 'cbpQTRotator' );
        if ( !instance ) {
          logError( "cannot call methods on cbpQTRotator prior to initialization; " +
          "attempted to call method '" + options + "'" );
          return;
        }
        if ( !$.isFunction( instance[options] ) || options.charAt(0) === "_" ) {
          logError( "no such method '" + options + "' for cbpQTRotator instance" );
          return;
        }
        instance[ options ].apply( instance, args );
      });
    }
    else {
      this.each(function() {
        var instance = $.data( this, 'cbpQTRotator' );
        if ( instance ) {
          instance._init();
        }
        else {
          instance = $.data( this, 'cbpQTRotator', new $.CBPQTRotator( options, this ) );
        }
      });
    }
    return this;
  };

} )( jQuery, window );
*/

(function($) {


  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      sendMessage: function(container, type, message ) {
          function closeConatainer() {
              $(container).removeClass(type).removeClass('open');
          }
          $(container).addClass(type)
              .addClass('open')
              .find('.r-message')
              .html(message);
          $(container).find('.close').click(function(e) {
              e.preventDefault();
              closeConatainer();
          });
          setTimeout( closeConatainer, 5000);

      },
      init: function() {

        // Typekit init
        try {
          Typekit.load();
        } catch(e) {}

          // Animated header

          var cbpAnimatedHeader = (function() {

              var docElem = document.documentElement,
                  header = $( '.navbar-fixed-top' ),
                  didScroll = false,
                  changeHeaderOn = 60;

              function scrollY() {
                  return window.pageYOffset || docElem.scrollTop;
              }

              function scrollPage() {
                  var sy = scrollY();
                  if ( sy >= changeHeaderOn ) {
                      header.addClass('navbar-shrink');
                  }
                  else {
                      header.removeClass('navbar-shrink' );
                  }
                  didScroll = false;
              }

              function init() {
                  window.addEventListener( 'scroll', function( event ) {
                      if( !didScroll ) {
                          didScroll = true;
                          setTimeout( scrollPage, 250 );
                      }
                  }, false );
              }

              init();

          })();

        // JavaScript to be fired on all pages
        equalheight = function(container){

          var currentTallest = 0,
              currentRowStart = 0,
              rowDivs = [],
              $el,
              topPosition = 0;
          $(container).each(function() {

            $el = $(this);
            $($el).height('auto');
            topPostion = $el.position().top;

            if (currentRowStart !== topPostion) {
              for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
              }
              rowDivs.length = 0; // empty the array
              currentRowStart = topPostion;
              currentTallest = $el.height();
              rowDivs.push($el);
            } else {
              rowDivs.push($el);
              currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
            }
            for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
              rowDivs[currentDiv].height(currentTallest);
            }
          });
        };

        $(window).load(function() {
          equalheight('.eqh-row .eqh');
        });


        $(window).resize(function(){
          equalheight('.eqh-row .eqh');
        });

          $('.dt-read-more').on('click', function(ev) {
              var eqh = $(this).closest('.eqh-row').find('.eqh'),
                  action = $(this).data('action');
                  ev.preventDefault();
              if(action === 'expand') {
                  $(this).siblings('p')
                      .addClass('dt-expanded')
                      .end()
                      .text('Read less')
                      .data('action', 'collapse');
                  equalheight(eqh);
              } else if(action === 'collapse') {
                  $(this).siblings('p')
                      .removeClass('dt-expanded')
                      .end()
                      .text('Read more')
                      .data('action', 'expand');
                  equalheight(eqh);
              }
          });

          /* newsletter */
         $('.newsletter-form').on('submit', function(e){
             e.preventDefault();
             var form = $(this),
                 btn = form.find('.btn');
             form.validator('validate');
             if($('input[type=email]').val().replace(/\s/g,"") === '')  {
                 Sage.common.sendMessage('.response', 'error', 'Make sure You filled all fields');
                 return false;
             }
             btn.button('loading');
             var posting = $.post(psData.ajaxUrl, $(this).serialize(), function(respond) {
                 if(respond.id) {
                     Sage.common.sendMessage('.response', 'success', 'Thank You for subscribing');
                     form.trigger('reset');
                 } else if(respond.status === 400)
                 {
                     Sage.common.sendMessage('.response', 'error', 'This email is already in list');
                 }
                 else {
                     Sage.common.sendMessage('.response', 'error', 'An error was occurred. Please try again later');
                 }
             })
                 .always(function() {
                     btn.button('reset');
                 })
                 .fail(function() {
                     Sage.common.sendMessage('.response', 'error', 'An error was occurred. Please try again later');
                 });
         });

        /* Fancybox init */

        $('.lightbox').fancybox();

        $('.testi-rotator').cycle();


          /* Off canvas Menu */
          var SidebarMenuEffects = {
              container: $( '.site' ),
              toggleBtn: $( '.navbar-toggle' ),
              closeBtn: $('.menu-close'),
              resetMenu: function() {
                  this.container.removeClass( 'menu-open' );
              },
              init: function() {
                  var that = this,
                      eventtype = 'click';
                  function hasParentClass( e, classname ) {
                      if(e === document) { return false; }
                      if( $(e).hasClass( classname ) ) {
                          return true;
                      }
                      return e.parentNode && hasParentClass( e.parentNode, classname );
                  }
                  function bodyClickFn(evt) {
                      if( !hasParentClass( evt.target, 'om-inner' ) ) {
                          that.resetMenu();
                          $(document).off( eventtype, bodyClickFn );
                      }
                  }
                  this.closeBtn.on(eventtype, function(ev) {
                      ev.preventDefault();
                      that.resetMenu();
                  });
                  this.toggleBtn.on(eventtype, function(ev) {
                      ev.stopPropagation();
                      ev.preventDefault();
                      setTimeout( function() {
                          that.container.addClass( 'menu-open' );
                      }, 25 );
                      $(document).on(eventtype, bodyClickFn);
                  });
              }
          };
          SidebarMenuEffects.init();

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
          if ("ontouchstart" in document.documentElement) {

              $('#slider').nivoSlider({
                  effect: 'slideInLeft',
                  animSpeed: 100,
                  pauseTime: 4000
              });

              $('a.nivo-nextNav').css('visibility', 'hidden');
              $('a.nivo-prevNav').css('visibility', 'hidden');

              var element = document.getElementById('slider');

              var hammeleft = new Hammer(element).on("swipeleft", function(event) {
                  $('#slider img').attr("data-transition","slideInLeft");
                  $('a.nivo-nextNav').trigger('click');
                  return false;

              });

              var hammerright = new Hammer(element).on("swiperight", function(event) {
                  $('#slider img').attr("data-transition","slideInRight");
                  $('a.nivo-prevNav').trigger('click');
                  $('#slider img').attr("data-transition","slideInLeft");
                  return false;

              });

          } else {
              $('#slider').nivoSlider({
                  effect: 'fade',
                  pauseTime: 3000,
                  animSpeed: 500,
                  controlNav: true
              });
          }
        //$( '#qtrotator' ).cbpQTRotator();
          $('.owl-carousel').owlCarousel({
              loop: true,
              lazyLoad: true,
              responsive:{
                  0: {
                      items:1,
                      margin: 0,
                      nav:false,
                      dots: true
                  },
                  480:{
                      items:2,
                      margin: 10,
                      nav:false,
                      dots: true
                  },
                  768:{
                      items:3,
                      margin: 15,
                      nav:true,
                      dots: false
                  },
                  992:{
                      items:4,
                      margin: 20,
                      nav: true,
                      dots: false
                  }
              }

          });
          $('.ps_add_to_cart').on('click', function(ev) {
              ev.preventDefault();
          });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'locations': {
      init: function() {
        // JavaScript to be fired on the about us page
        var map,
            infowindow = null,
            markers = [],
            locations = psData.locations;

          function setInfowindow() {
              infowindow.setContent(this.html);
              infowindow.open(map, this);
              map.setCenter(this.getPosition());
              map.setZoom(15);
          }
          function setMarkers(map, locations) {
              for (var i = 0; i < locations.length; i++) {
                  var store = locations[i];
                  var myLatLng = new google.maps.LatLng(store[1], store[2]);
                  var marker = new google.maps.Marker({
                      position: myLatLng,
                      map: map,
                      icon: psData.icon,
                      title: store[0],
                      html: '<div class="infowindow">' +
                            '<h2>' + store[5] + '</h2>' +
                            '<address>' + store[3] + '</address>' +
                            '<address><abbr title="phone">Phone:</abbr> <a href="tel:1300858199">1300 858 199</a>' +
                            '<abbr title="email">Email:</abbr> <a href="mailto:info@puresmile.com.au">info@puresmile.com.au</a></address>' +
                            '<a href="' + psData.bookurl + '?location=' + store[4] + '" class="iw-book">Book Now</a>' +
                            '</div>'
                  });
                  google.maps.event.addListener(marker, 'click', setInfowindow);

                  // Push the marker to the 'markers' array
                  markers.push(marker);
              }
          }

        function initialize() {
          var mapOptions = {
            zoom: parseInt(psData.mapZoom),
            center: new google.maps.LatLng(parseFloat(psData.mapCenterLat), parseFloat(psData.mapCenterLng))
          };

          map = new google.maps.Map(document.getElementById('map-canvas'),
              mapOptions);
          setMarkers(map, locations);
          infowindow = new google.maps.InfoWindow({
            content: "loading..."
          });
        }
        google.maps.event.addDomListener(window, 'load', initialize);
      }
    },
    'dentists_locations': {
        init: function() {
            // JavaScript to be fired on the about us page
            var map,
                infowindow = null,
                markers = [],
                locations = psData.locations,
                bounds;

            function setInfowindow() {
                infowindow.setContent(this.html);
                infowindow.open(map, this);
                map.setCenter(this.getPosition());
                map.setZoom(15);
            }
            function setMarkers(map, locations) {
                if(locations.length > 0) {
                    for (var i = 0; i < locations.length; i++) {
                        var store = locations[i];
                        var myLatLng = new google.maps.LatLng(store[1], store[2]);
                        var marker = new google.maps.Marker({
                            position: myLatLng,
                            map: map,
                            icon: psData.icon,
                            title: store[0],
                            html: '<div class="infowindow">' +
                            '<h2>' + store[5] + '</h2>' +
                            '<address>' + store[3] + '</address>' +
                            '<address><abbr title="phone">Phone:</abbr> <a href="tel:1300858199">1300 858 199</a>' +
                            '<abbr title="email">Email:</abbr> <a href="mailto:info@puresmile.com.au">info@puresmile.com.au</a></address>' +
                            '<a href="' + psData.bookurl + '?location=' + store[4] + '" class="iw-book">Book Now</a>' +
                            '</div>'
                        });
                        bounds.extend(marker.getPosition());
                        google.maps.event.addListener(marker, 'click', setInfowindow);

                        // Push the marker to the 'markers' array
                        markers.push(marker);
                    }
                    map.fitBounds(bounds);
                }
            }

            function initialize() {
                var mapOptions = {
                    zoom: parseInt(psData.mapZoom),
                    center: new google.maps.LatLng(parseFloat(psData.mapCenterLat), parseFloat(psData.mapCenterLng))
                };
                bounds = new google.maps.LatLngBounds();

                map = new google.maps.Map(document.getElementById('map-canvas'),
                    mapOptions);
                setMarkers(map, locations);
                infowindow = new google.maps.InfoWindow({
                    content: "loading..."
                });
            }
            google.maps.event.addDomListener(window, 'load', initialize);
        }
    },
    'page_template_template_booking': {
      init: function() {
          $(function () {
              $('[data-toggle="popover"]').popover({
                  trigger: 'hover'
              });
          });

          var inputDatajqObj = $('#datepicker');

          var inputDate = inputDatajqObj.pickadate({
              format: 'dd-mm-yyyy',
              firstDay: 1,
              min: true,
              max: false
            });
          var inputTime = $('#timepicker').pickatime({
              format: 'HH:i',
              min: [9,0],
              max: [18,0]
          });

          var limits = {
              1: { //Auckland – Eden Park
                  1: {
                      min: [10,30],
                      max: [17,0]
                  },
                  2: {
                      min: [10,30],
                      max: [17,0]
                  },
                  3: {
                      min: [10,30],
                      max: [17,0]
                  },
                  4: {
                      min: [10,30],
                      max: [17,0]
                  },
                  5: {
                      min: [10,30],
                      max: [17,0]
                  },
                  6: {
                      min: [12,0],
                      max: [15,0]
                  },
                  0: {
                      min: [0,0],
                      max: [0,0]
                  }
              },
              2: { //Christchurch –  Woodend
                  1: {
                      min: [10,0],
                      max: [16,0]
                  },
                  2: {
                      min: [10,0],
                      max: [16,0]
                  },
                  3: {
                      min: [10,0],
                      max: [16,0]
                  },
                  4: {
                      min: [10,0],
                      max: [16,0]
                  },
                  5: {
                      min: [10,0],
                      max: [16,0]
                  },
                  6: {
                      min: [0,0],
                      max: [0,0]
                  },
                  0: {
                      min: [0,0],
                      max: [0,0]
                  }
              }
          };


          var pickerTime = inputTime.pickatime('picker');
          var pickerDate = inputDate.pickadate('picker');

          function getLocationCode() {
              var location = $('input[type=radio][name=location]').filter(':checked').val();
              switch(location) {
                  case "Auckland – Eden Park":
                      return 1;
                  case "Christchurch –  Woodend":
                      return 2;
                  default :
                      return 1;
              }
          }
          function setLimits() {
              var date = pickerDate.get('select'),
                  location = getLocationCode();
              pickerTime.set(limits[location][date.day]);
          }


          inputDatajqObj.on('change', setLimits);
          pickerDate.on('set', function() {
              var selected = this.get('value', 'dd-mm-yyyy'),
                  today = new Date(),
                  dd = today.getDate(),
                  mm = today.getMonth()+ 1,
                  yyyy = today.getFullYear(),
                  currHour = today.getHours(),
                  currMin = parseInt(pickerTime.get('min', 'h'));
              if(dd<10){
                  dd = '0' + dd;
              }
              if(mm<10){
                  mm = '0' + mm;
              }
              today = dd+'-'+mm+'-'+yyyy;
              if((selected === today)) {
                  if(currHour <= currMin) {
                      pickerTime.set({
                          min: [currMin + 3, 0]
                      });
                  } else {
                      pickerTime.set({
                          min: [currHour + 3, 0]
                      });
                  }

              }

          });


          $('input[type=radio][name=location]').on('change', function() {
              var location = getLocationCode();
              /*var currDate = new Date();
              var currDay = currDate.getDay();
              var currHour = currDate.getHours();
              var dayLimits; */
              inputDatajqObj.off('change', setLimits);
              pickerDate.clear();
              pickerTime.clear();
              if( location === 1 ) {
                  pickerDate.set({
                      disable: [7]
                  });
              } else if( location === 2 ) {
                  pickerDate.set({
                      disable: [6,7]
                  });
              } else {
                  pickerDate.set({
                      enable: [1,2,3,4,5,6,7]
                  });
              }
              pickerDate.set({
                  min: true,
                  max: false
              });

              inputDatajqObj.on('change', setLimits);
          });

          /* Trigger input change on page load  */

          $(window).on('load', function() {
              $('input[type=radio][name=location]').trigger('change');
          });


        /* Ajax booking form */

        var bf = $("#book-form");
        bf.validator();
        var btn = $("#send");
        var msg = $(".output-message");
        btn.click(function(event) {
          bf.validator('validate');
          if(($('#name').val().replace(/\s/g,"") === '') || ($('#phone').val().replace(/\s/g,"") === '') || ($("#email").val().replace(/\s/g,"") === '') || ($('#datepicker').val().replace(/\s/g,"") === '') || ($('#timepicker').val().replace(/\s/g,"") === '')) {
            msg.text('Make sure You filled all fields');
            return false;
          }
          event.preventDefault();
          btn.button('loading');
          $.ajax({
            url: psData.ajaxUrl,
            data: bf.serialize(),
            type: 'post',
            success: function (respond) {
                if(respond.id) {
                    $('#custom').val(respond.id);
                    msg.text(respond.text);
                    bf.submit();
                } else {
                    msg.text('Something went wrong. Please try again');
                }
                btn.button('reset');
            },
            fail: function() {
              msg.text('Error. Please try again later');
              btn.button('reset');
            }
          });

        });

      }
    },
    'promotion': {
        init: function() {
            Sage.page_template_template_booking.init();
        }
    },
    'wwof_woocommerce': {
        init: function() {
            $( document ).ajaxComplete(function() {
                equalheight('.eqh-row .eqh');
            });
        }
    },
    'page_registration': {
        init: function() {
            var regForm = $('#registration-form');
            var msg = $(".output-message");
            var btn = $("#send");
            regForm.validator().on('submit', function(ev) {
                msg.text('');
                if (!ev.isDefaultPrevented()) {
                    ev.preventDefault();
                    btn.button('loading');
                    $.ajax({
                        url: psData.ajaxUrl,
                        data: regForm.serialize(),
                        type: 'post',
                        success: function (respond) {
                            if(respond.error) {
                                msg.text(respond.message);
                            } else {
                                $('.thank-you').fadeIn(500);
                                regForm.trigger('reset');
                            }
                        },
                        fail: function () {
                            msg.text('An error was occurred, please try again later');
                        },
                        complete: function () {
                            btn.button('reset');

                        }
                    });
                }
            });
        }
    },
    'page_store': {
        init: function() {
            var map,
                infowindow = null,
                markers = [],
                locations = psData.locations;

            function setInfowindow() {
                infowindow.setContent(this.html);
                infowindow.open(map, this);
                map.setCenter(this.getPosition());
                map.setZoom(15);
            }
            function setMarkers(map, locations) {
                for (var i = 0; i < locations.length; i++) {
                    var store = locations[i];
                    var myLatLng = new google.maps.LatLng(store[1], store[2]);
                    var marker = new google.maps.Marker({
                        position: myLatLng,
                        map: map,
                        icon: psData.icon,
                        title: store[0],
                        html: '<div class="infowindow">' +
                               '<address>' + store[3] + '</address>' +
                               '</div>'
                    });
                    google.maps.event.addListener(marker, 'click', setInfowindow);

                    // Push the marker to the 'markers' array
                    markers.push(marker);
                }
            }

            function initialize() {
                var mapOptions = {
                    zoom: parseInt(psData.mapZoom),
                    center: new google.maps.LatLng(parseFloat(psData.mapCenterLat), parseFloat(psData.mapCenterLng))
                };

                map = new google.maps.Map(document.getElementById('map'),
                    mapOptions);
                setMarkers(map, locations);
                infowindow = new google.maps.InfoWindow({
                    content: "loading..."
                });
            }
            google.maps.event.addDomListener(window, 'load', initialize);

            $(document).ready(function(){
                $("a[rel^='prettyPhoto']").prettyPhoto({
                    slideshow: false, /* false OR interval time in ms */
                    autoplay_slideshow: false, /* true/false */
                    opacity: 0.9, /* Value between 0 and 1 */
                    show_title: false, /* true/false */
                    allow_resize: true, /* Resize the photos bigger than viewport. true/false */
                    default_width: 900,
                    default_height: 700,
                    counter_separator_label: ' of ', /* The separator for the gallery counter 1 "of" 2 */
                    theme: 'pp_puresmile', /* light_rounded / dark_rounded / light_square / dark_square / facebook */
                    horizontal_padding: 0, /* The padding on each side of the picture */
                    autoplay: false, /* Automatically start videos: True/False */
                    markup: '<div class="pp_pic_holder"> \
						<div class="ppt">&nbsp;</div> \
						<div class="pp_top"> \
							<div class="pp_middle"><p class="currentTextHolder">0 of 0</p></div> \
							<div class="pp_right"><a class="pp_close" href="#">Close</a></div> \
						</div> \
						<div class="pp_content_container"> \
							<div class="pp_left"> \
							<div class="pp_right"> \
								<div class="pp_content"> \
									<div class="pp_loaderIcon"><i class="fa fa-spinner fa-pulse fa-fw"></i></div> \
									<div class="pp_fade"> \
										<div class="pp_hoverContainer" style="display: none;"> \
										</div> \
										<div id="pp_full_res"></div> \
										<div class="pp_details"> \
										    <a class="pp_next" href="#">next</a> \
											<a class="pp_previous" href="#">previous</a> \
										</div> \
									</div> \
								</div> \
							</div> \
							</div> \
						</div> \
					</div> \
					<div class="pp_overlay"></div>',
                    gallery_markup: '',
                    image_markup: '<img id="fullResImage" src="{path}" />',
                    social_tools: false
                });
            });
            $('.show-all').on('click', function(ev) {
                ev.preventDefault();
                $('.gallery-list li:first-child a').trigger('click');
            });
        }
    },
    'page_template_template_dentist': {
        init: function() {
            function hideReadMore() {
                $('.ds-ext-box').each(function () {
                    var height = $(this).find('p').height(),
                        minHeight = parseInt($(this).data('height'));

                    if (height < minHeight) {
                        $(this).find('.dt-read-more').hide();
                    } else {
                        $(this).find('.dt-read-more').show();
                    }
                });
            }
             $(window).on('load', hideReadMore);
             $(window).on('resize', hideReadMore);


        }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
